var map = {
	"./1.svg": "4bc0",
	"./10.svg": "65cb",
	"./11.svg": "b36a",
	"./12.svg": "96a4",
	"./13.svg": "3a47",
	"./14.svg": "1550",
	"./15.svg": "80ec",
	"./16.svg": "8078",
	"./17.svg": "51f9",
	"./2.svg": "ad04",
	"./3.svg": "fe01",
	"./4.svg": "33b3",
	"./5.svg": "ac28",
	"./6.svg": "0ced",
	"./7.svg": "0762",
	"./8.svg": "3444",
	"./9.svg": "c1b1",
	"./sdg.svg": "fe6b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "952f";